<template>
  <MainLayout page-name="invoice-inquiry">
    <PageHeader :title="title">
      <el-row class="header-button">
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <!-- 20220512髙森追記 請求年月-->
        <!-- <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="this" :required="true" /> -->
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="invoice" />
        <!-- ここまで -->
        <!-- <BillToCode v-model="simpleSearchFormModel.bill_to_code" prop ="bill_to_code" :searchCond="true" :initialize="true"
            label = "" placeholder="請求先" :disabled="decisionDisabled()"/> -->
        <BillToCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true"
            label="請求先" prop="bill_to_code" :disabled="decisionDisabled()"/>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'bill_to_code', order: 'ascending' }"
      :multiSelect="multiSelectable"
      :selectable="selectable"
      programId="InvoiceInquiry"
      @clickExcel="clickExcel"
      @clickPdf="clickPdf"
    >
      <template #columns>
        <!-- <BillToCodeColumn label="請求先" :sortable="true" />
        <BillingYmColumn label="請求年月" :sortable="true" />
        <ExcelFileNameColumn label="Excelファイル名" prop="excel_file_name" :sortable="true" @filedownload="download"/>
        <PdfFileNameColumn label="PDFファイル名" prop="pdf_file_name" :sortable="true"  @filedownload="download"/>
        <BlankColumn /> -->
        <BillToCodeColumn label="請求先" />
        <BillingYmColumn label="請求年月" />
        <ExcelFileNameColumn label="Excelファイル名" prop="excel_file_name" @filedownload="download"/>
        <PdfFileNameColumn label="PDFファイル名" prop="pdf_file_name"  @filedownload="download"/>
        <BlankColumn />
      </template>
    </Table>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
// import BillToCode from '@/components/molecules/form/select/CustomerCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
// import Table from '@/components/molecules/table/TablePaging.vue'
import Table from '@/components/molecules/table/TableInvoicePaging.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import BillingYmColumn from '@/components/molecules/table/BillingYmColumn.vue'
import ExcelFileNameColumn from '@/components/molecules/table/ExcelFileNameColumn.vue'
import PdfFileNameColumn from '@/components/molecules/table/PdfFileNameColumn.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    // 20220512髙森追記
    BillingYm,
    // ここまで
    BillToCode,
    SimpleSearch,
    Table,
    BillToCodeColumn,
    BillingYmColumn,
    ExcelFileNameColumn,
    PdfFileNameColumn,
    BlankColumn
  },
  mixins: [
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '請求書照会',
      tableData: [],
      simpleSearchFormModel: {
        // 20220512髙森追記
        billing_ym: this.getDefaultBillingYm(),
        // ここまで
        bill_to_code: ''
      },
      currentRow: {}
      // calculationDialogVisible: false,
      // registerDialogVisible: false,
      // detailDalogVisible: false,
      // editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForPaidPassengersSearchCond')
    this.loadCustomer()
  },
  methods: {
    decisionDisabled () {
      var result = false
      if (this.$loginuser.get('role_id').indexOf('airline') !== -1) {
        result = true
        this.simpleSearchFormModel.bill_to_code = this.$loginuser.get('customer_code')
      }
      return result
    },
    multiSelectable () {
      // 複数選択可能条件
      return ((this.$loginuser.get('role_id').indexOf('airport') !== -1) | (this.$loginuser.get('role_id') === 'admin'))
    },
    selectable (row, index) {
      // 選択可能条件
      return (!(!row.excel_file_name) | !(!row.pdf_file_name))
    },
    // clickCalculation () {
    //   this.calculationDialogVisible = true
    // },
    // clickRegister () {
    //   this.currentRow = {}
    //   this.registerDialogVisible = true
    // },
    // clickDetailSearch () {
    //   this.detailDalogVisible = true
    // },
    clickSearch () {
      sessionStorage.setItem('feesForPaidPassengersSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    // detailSearch () {
    //   const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
    //   Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
    //   this.search()
    // },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
      this.$axios
        .get('/search-invoice-inquiry', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    async download (row) {
      this.$loadingMask.on()
      const downloadParams = {}
      downloadParams.billing_ym = row.billing_ym
      downloadParams.bill_to_code = row.bill_to_code
      if (row.syori === 'excel') {
        downloadParams.fileName = row.excel_file_name
      } else {
        downloadParams.fileName = row.pdf_file_name
      }
      await this.$axios
        .get('/invoice-operation/signed-url', { params: downloadParams })
        .then((res) => {
          this.clickFileDownload(res.data.list, downloadParams.fileName)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    clickFileDownload (sigendURL, fileName) {
      const link = document.createElement('a')
      // link.href = window.URL.createObjectURL(sigendURL)
      link.href = sigendURL
      link.download = fileName
      link.click()
    },
    async clickExcel (rows) {
      await this.clickMultiDownload(rows, 'Excel')
    },
    async clickPdf (rows) {
      await this.clickMultiDownload(rows, 'PDF')
    },
    async clickMultiDownload (rows, syori) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0008W', '請求書' + syori))) {
        return
      }
      try {
        this.$loadingMask.on()
        // 例外が発生した場合の処理
        var apiResult = {}
        apiResult = await this.MultiDownload(rows, syori)
        if (apiResult.presigned_url) {
          this.clickFileDownload(apiResult.presigned_url, '一括ダウンロード請求書_' + syori + '.zip')
          await this.deleteDownloadFolder(apiResult.folder_name)
          this.search()
        } else {
          if (!(await this.$fcMessage.messageBox(this.title, 'CMN0012E', '請求書' + syori))) {
            return
          }
        }
      } catch (e) {
        // 例外が発生した場合の処理
        console.log(e)
      } finally {
        // 必ず実行される処理
        this.$loadingMask.off()
      }
    },
    async MultiDownload (rows, syori) {
      // if (!(await this.$fcMessage.messageBox(this.title, 'CMN0005W', '請求書' + syori))) {
      //   return
      // }

      const params = this.parameterSet(rows, syori)
      var apiResult = {}
      if (params.length > 0) {
        // this.$loadingMask.on()
        await this.$axios
          .put('/invoice-operation/multi-operation', { download_file: params, file_type: syori })
          .then((res) => {
            apiResult = res.data.list
            // this.clickFileDownload(apiResult.presigned_url, '一括ダウンロード請求書_' + syori + '.zip')
            // this.deleteDownloadFolder(apiResult.folder_name)
            // this.search()
          })
          .catch((e) => {
            if (e.response) {
              switch (e.response.status) {
                case 402:
                  this.$fcMessage.showMessage(e.response.data.message, true)
                  this.search()
                  break
                default:
              }
            }
          })
          // .finally(() => {
          //   this.search()
          //   this.$loadingMask.off()
          // })
      } else {
        console.log('未選択')
      }
      return apiResult
    },
    parameterSet (rows, syori) {
      var params = []
      for (let i = 0; i <= rows.length - 1; i++) {
        var param = {}
        param.billing_ym = rows[i].billing_ym
        param.bill_to_code = rows[i].bill_to_code
        switch (syori) {
          case 'Excel':
            if ((rows[i].excel_file_name).trim() !== '') {
              param.fileName = rows[i].excel_file_name
            }
            break
          case 'PDF':
            if ((rows[i].pdf_file_name).trim() !== '') {
              param.fileName = rows[i].pdf_file_name
            }
            break
          default:
        }
        if (param.fileName) {
          params.push(param)
        }
      }
      return params
    },
    async deleteDownloadFolder (folderName) {
      const params = { folder_name: folderName }
      await this.$axios
        .delete('/invoice-operation/multi-operation', { data: params })
        .then((res) => {
          console.log(res)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                this.search()
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  height: 40px;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}

</style>
